<template>
  <div class="record" @click="navigateToDetail">
    <div class="header">
      <div class="icon"></div>
      <div class="label">{{ detail.title }}</div>
      <div class="time">{{ detail.applyTime }}</div>
    </div>
    <div class="body">
      <div class="title">
        <div class="text">
          {{ detail.approveMsg && detail.approveMsg.title }}
        </div>
        <div class="tag" :class="[detail.status]">{{ detail.statusName }}</div>
      </div>
      <!-- <div class="info">
        时长：{{ detail.approveMsg && detail.approveMsg.leaveHours }}
      </div>
      <div class="info">
        开始时间：{{ detail.approveMsg && detail.approveMsg.startTime }}
      </div>
      <div class="info">
        结束时间：{{ detail.approveMsg && detail.approveMsg.endTime }}
      </div> -->
      <div
        class="info"
        style="white-space: pre"
        v-html="detail.approveMsg && detail.approveMsg.content"
      ></div>
      <div class="status">{{ detail.approvalDescription }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TodoItem",
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    navigateToDetail() {
      // todo
      let { bizType } = this.detail;
      if (bizType == "student_leave") {
        this.$router.push({
          path: "/leaveDetail",
          query: {
            id: this.detail.detailId,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.record {
  padding: 12px 0;
  border-radius: 8px;
  background-color: #fff;
  margin: 10px 15px;
  .header {
    display: flex;
    height: 44px;
    align-items: center;
    color: #999;
    font-weight: 400;
    font-size: 13px;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 12px;
    .icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 8px;
    }
    .label {
      flex: 1;
    }
  }
  .body {
    color: #666666;
    font-size: 15px;
    font-weight: 400;
    padding: 0 12px;
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 48px;
      .text {
        color: #333;
        font-size: 17px;
        font-weight: 600;
      }
      .tag {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 55px;
        height: 20px;
        color: #4275fd;
        font-size: 13px;
        font-weight: 400;
        border-radius: 20px 0 0 20px;
        background: #4275fd33;
        margin-right: -12px;
        &.underway {
          color: #ff8948;
          background: rgba(255, 137, 72, 0.2);
        }
        &.revoke {
          color: RGBA(216, 216, 216, 1);
          background: RGBA(216, 216, 216, 0.2);
        }
        &.agree {
          color: #4275fd;
          background: #4275fd33;
        }
        &.refuse {
          color: rgba(254, 79, 84, 1);
          background: rgba(254, 79, 84, 0.2);
        }
        &.finish {
          color: #00c73d;
          background: rgba(0, 199, 61, 0.2);
        }
      }
    }
    .info {
      color: #666666;
    }
    .status {
      color: #ff8948ff;
      margin-top: 12px;
    }
  }
}
</style>